import component from './DestinationSelectorContainer';

export default component;
